<template>
    <div>
        <b-navbar toggleable="sm" type="light" variant="light" class="navbar">
            <b-navbar-brand href="#">
                <img src="NS_logo.jpg" width="30px" height="30px">
            </b-navbar-brand>

            <b-navbar-brand v-if="currentUserRole.role==='admin'" to="/admin">{{title}}</b-navbar-brand>
            <b-navbar-brand v-else-if="currentUserRole.role==='host'" to="/host">{{title}}</b-navbar-brand>
            <b-navbar-brand v-else to="/">{{title}}</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav v-if="currentUserRole.role==='admin'">
                    <b-nav-item to="/events">
                        Events
                    </b-nav-item>
                    <b-nav-item to="/tickets">
                        Tickets
                    </b-nav-item>
                    <b-nav-item to="/users">
                        Users
                    </b-nav-item>
                    <b-nav-item to="/host">
                        Guida
                    </b-nav-item>
                    <b-nav-item to="/client">
                        Client
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">

                    <b-nav-item-dropdown right v-if="currentUserRole.id">
                        <template v-slot:button-content>
                            <em>{{currentUserRole.nome}}</em>
                        </template>
                        <b-dropdown-item href="#" @click="signout">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown :text="active_language" right v-if="!currentUserRole.id">
                        <b-dropdown-item v-for="lang in languages" :key="lang" @click="updateLang(lang)">{{lang}}</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
    import {mapMutations, mapGetters } from "vuex";

    export default {
        name: "adminbar",
        props: ['title'],
        data () {
            return {
                languages:[
                    'IT',
                    'DE',
                    'EN',
                    'ES',
                    'FR'
                ],
                active_language: 'IT'
            }
        },
        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters([
                'currentUserRole'
            ])
        },
        methods:{
            ...mapMutations(['setCurrentUser', "setCurrentUserRole"]),
            signout: function() {
                this.$firebase.auth.signOut().then(function() {
                    this.setCurrentUser(null);
                    this.setCurrentUserRole(null);
                    this.$router.push('/');
                }.bind(this)).catch(function(error) {
                    // An error happened.
                    console.log(error);
                });
            },
            updateLang: function (_lang) {
                this.$emit('languageChanged', _lang);
                this.active_language = _lang
            },
            getActiveLanguage() {
                return this.active_language;
            }
        }
    }
</script>

<style scoped>

    .navbar{
        max-height:50px;
        border-bottom: 2px solid rgba(0, 0, 0, 0.20);
        border-top: 2px solid rgba(0, 0, 0, 0.20);
    }

    @media screen and (max-width: 768px) {

        .navbar{
            max-height:100%;

        }
    }

    @media screen and (max-width: 400px) {

        .navbar-brand{
            font-size: 1em;
        }
    }

</style>
